import { Loader } from "components";
import { useFormik } from "formik";
import { useState } from "react";
import { object, string } from 'yup';
import { AuthorizationService } from "services";
import { NavLink, useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const initialValues = { emailAddress: '' };
  const navigate = useNavigate();

  const validationSchema = object().shape({
    emailAddress: string().required("Email Address is required"),
  });

  const { errors, values, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: async () => {
        console.log("is submitted")
        setIsLoading(true);
        setErrorMessage("");
        AuthorizationService.ForgotPassword(values.emailAddress)
        .then((res) => {
          setIsLoading(false);
          navigate(`/reset-password?token=${res.data.token}`);
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response.status === 401) {
            setErrorMessage("Invalid email address or password");
            return;
          }
          setErrorMessage("Something wrong happened. Please try again later");
        })
      },
    });

  return (
    <div className="col-12 col-md-8 col-xl-6 mx-auto">
      <h2 className="text-center mb-4">Forgot Your Password?</h2>
      { !isSubmitted ?
        <form onSubmit={handleSubmit}>
          <p className="text-center">
            Fear not. We'll email you instructions to reset your password. If you
            don't have access to your email, please reach out to{" "}
            <b>info@zanifu.com</b>
          </p>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          {isLoading ? (
            <Loader />
          ) : (
            <>
                <div className="form-group mt-4 mb-3">
                    <label>Email address / Phone number</label>
                    <input
                        name="emailAddress"
                        className={`form-input ${
                        Boolean(touched.emailAddress && errors.emailAddress)
                            ? "error-field"
                            : ""
                        }`}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.emailAddress}
                        type="text"
                        placeholder="Enter email address / phone number"
                        required
                    />
                    {Boolean(touched.emailAddress && errors.emailAddress) && (
                        <p className="error mt-2"> {errors.emailAddress}</p>
                    )}
                </div>
                <button className="btn btn-primary btn-full mt-3" 
                    type="submit">
                    Reset Password
                </button>
                <NavLink to="/sign-in" className="primary-color float-end mt-3">
                    <span>Return to Login</span>
                </NavLink>
            </>
          )}
        </form> :
        <div className="text-center">
          <p className='mb-4'>An email / phone number has been sent to the address associated with your account.</p>
          <p className='mb-4'>Please check your inbox for further instructions on how to reset your password. If you don't receive an email / sms within a few minutes, please contact support.</p>
        </div>
      }
    </div>
  );
}

export default ForgotPasswordPage;